import { Link } from 'react-router-dom';
import { useState } from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('https://readdy.ai/api/form/d61mo2bn6d2i4h4oab3g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          nombre: formData.nombre,
          telefono: formData.telefono,
          mensaje: formData.mensaje,
        }).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', telefono: '', mensaje: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-dark-card border-t border-dark-lighter">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo y descripción */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/06424b75-440f-4c86-baff-26ebcba943a6.png"
                alt="PLADUREX"
                className="h-10 w-auto"
              />
              <span className="text-xl font-display font-bold text-light-text">
                PLADUREX
              </span>
            </div>
            <p className="text-light-muted text-sm leading-relaxed">
              Especialistas en instalación de pladur en Sabadell y alrededores. Soluciones profesionales para tabiques, techos y aislamientos.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-light-text font-semibold mb-4">Enlaces</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-light-text font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios#tabiques" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Tabiques de pladur
                </Link>
              </li>
              <li>
                <Link to="/servicios#trasdosados" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Trasdosados
                </Link>
              </li>
              <li>
                <Link to="/servicios#techos" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Falsos techos
                </Link>
              </li>
              <li>
                <Link to="/servicios#acustico" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Aislamiento acústico
                </Link>
              </li>
              <li>
                <Link to="/servicios#termico" className="text-light-muted hover:text-primary-orange transition-colors text-sm">
                  Aislamiento térmico
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-light-text font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+34629501941"
                  className="flex items-center space-x-2 text-light-muted hover:text-primary-orange transition-colors text-sm"
                >
                  <i className="ri-phone-line"></i>
                  <span>+34 629 501 941</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-light-muted hover:text-primary-orange transition-colors text-sm"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>WhatsApp</span>
                </a>
              </li>
              <li className="flex items-start space-x-2 text-light-muted text-sm">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>Área de servicio: Sabadell, Vallès, Barcelona</span>
              </li>
            </ul>
          </div>

          {/* Formulario de contacto rápido */}
          <div>
            <h4 className="text-light-text font-semibold mb-4">Contacto Rápido</h4>
            <form 
              id="footer-contact-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-3"
            >
              <input
                type="text"
                name="nombre"
                placeholder="Tu nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                required
                className="w-full px-3 py-2 bg-dark-lighter border border-dark-lighter rounded-md text-sm text-light-text placeholder-light-muted focus:outline-none focus:border-primary-orange transition-colors"
              />
              <input
                type="tel"
                name="telefono"
                placeholder="Tu teléfono"
                value={formData.telefono}
                onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                required
                className="w-full px-3 py-2 bg-dark-lighter border border-dark-lighter rounded-md text-sm text-light-text placeholder-light-muted focus:outline-none focus:border-primary-orange transition-colors"
              />
              <textarea
                name="mensaje"
                placeholder="¿En qué podemos ayudarte?"
                value={formData.mensaje}
                onChange={(e) => setFormData({ ...formData, mensaje: e.target.value })}
                required
                maxLength={500}
                rows={3}
                className="w-full px-3 py-2 bg-dark-lighter border border-dark-lighter rounded-md text-sm text-light-text placeholder-light-muted focus:outline-none focus:border-primary-orange transition-colors resize-none"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-4 py-2 bg-primary-orange text-dark-bg font-semibold text-sm rounded-md hover:bg-primary-orange-dark transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
              </button>
              {submitStatus === 'success' && (
                <p className="text-green-500 text-xs text-center">¡Mensaje enviado correctamente!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-500 text-xs text-center">Error al enviar. Inténtalo de nuevo.</p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-dark-lighter mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-light-muted text-sm">
              © {currentYear} PLADUREX. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
              <Link
                to="/politica-privacidad"
                className="text-light-muted hover:text-primary-orange transition-colors"
              >
                Política de privacidad
              </Link>
              <Link
                to="/aviso-legal"
                className="text-light-muted hover:text-primary-orange transition-colors"
              >
                Aviso legal
              </Link>
              <Link
                to="/politica-cookies"
                className="text-light-muted hover:text-primary-orange transition-colors"
              >
                Política de cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
